import React from 'react';
import { useSelector } from 'react-redux';
import SignUpPage from '../../components/auth/sign-up';
import AuthLayout from '../../components/layout/AuthLayout';
import SEO from '../../components/seo';

const SignUp = () => {
    const { configData } = useSelector((state) => state.configData);

  return (
    <>
      <SEO
        title={configData ? `Sign Up - ${configData?.business_name}` : "Sign Up"}
        description="Create a new account"
        image={`${configData?.base_urls?.business_logo_url}/${configData?.fav_icon}`}
        businessName={configData?.business_name}
      />
      <AuthLayout>
        <SignUpPage configData={configData} />
      </AuthLayout>
    </>
  );
};

export default SignUp;